function ConnectController($route, $rootScope, $location) {
	"ngInject";

  //Make sure they logged out
  $rootScope.Loggedin = false;

  //Display Login Required Modal
  jQuery(document).ready(function ($) {
      //$('#modal').show();
     // $('#login-required').fadeIn(500);
      //$('#sign-up').fadeIn(500);
  });

  //Set the URL path to the homepage
  $location.url($location.path('/').replace());
  $location.path('/').replace();
  $route.reload();
};

export default {
  name: 'connectController',
  fn:ConnectController
};